import { Link, NavLink, useNavigate } from "react-router-dom";
import { LogOut, Plus, Snowflake } from "lucide-react";
import { useLang } from "../lib/i18n";
import { useAuth } from "../lib/auth";

export const HeaderNav = ({ tall = false }) => {
  const { lang, setLang, t } = useLang();
  const { user, logout } = useAuth();
  const nav = useNavigate();
  return (
    <header className={`frz-header ${tall ? "is-tall" : ""}`} data-testid="site-header">
      <div className="frz-header-bg" aria-hidden="true"
        style={tall ? undefined : { backgroundImage: "linear-gradient(180deg, rgba(7,17,31,0.55), rgba(7,17,31,0.88)), url(/brand/header.jpg)" }} />
      <nav className="frz-nav">
        <Link to="/" className="frz-brand" data-testid="brand-home-link">
          <img src="/brand/logo-256.jpg" alt="Frozer" className="frz-logo" data-testid="brand-logo" />
          <span className="frz-wordmark">Frozer</span>
        </Link>
        <div className="frz-nav-links">
          <NavLink to="/studio" className="frz-nav-link hide-xs" data-testid="nav-studio-link">{t("nav_studio")}</NavLink>
          <NavLink to="/creations" className="frz-nav-link" data-testid="nav-creations-link">{t("nav_creations")}</NavLink>
          {user ? (
            <Link to="/account" className="frz-credits" data-testid="header-credits" title={t("nav_account")}>
              <Snowflake size={14} /> <span data-testid="header-credits-value">{user.credits}</span><span className="hide-xs">&nbsp;{t(user.credits === 1 ? "credit_word_one" : "credit_word_many")}</span>
            </Link>
          ) : user === false ? (
            <Link to="/login" className="frz-nav-link frz-nav-login" data-testid="nav-login-link">{t("nav_login")}</Link>
          ) : null}
          {user && (
            <Link to="/recharge" className="frz-icon-btn" data-testid="header-recharge-button" aria-label={t("recharge")} title={t("recharge")}>
              <Plus size={16} />
            </Link>
          )}
          {user && (
            <button type="button" className="frz-icon-btn" onClick={() => { nav("/", { replace: true }); logout(); }} data-testid="header-logout-button" aria-label={t("logout")}>
              <LogOut size={16} />
            </button>
          )}
          <div className="frz-lang" role="group" aria-label="Language">
            {["fr", "en"].map((l) => (
              <button key={l} type="button" data-testid={`lang-toggle-${l}`} className={lang === l ? "on" : ""} onClick={() => setLang(l)}>
                {l.toUpperCase()}
              </button>
            ))}
          </div>
        </div>
      </nav>
    </header>
  );
};
